module.exports = __webpack_public_path__ + "img/B.d4e96d7f.png";